import { createSelector } from 'reselect';
import { isEmpty } from 'underscore';
import { ClipSuggestion } from 'blocks/ClipSelect/types';
import {
  CreationClipSuggestion,
  CreationResponse,
} from 'redux/middleware/api/creation-service/types';
import {
  creationClipSuggestionsSelector,
  creationsSelector,
  creationSuggestionSelector,
} from 'redux/modules/entities';
import { State } from 'redux/types';

const creationIdSelector = (_, creationId: number) => creationId;

function createClipSuggestion(
  s: CreationClipSuggestion,
): ClipSuggestion | undefined {
  if (!s) {
    return undefined;
  }

  const { suggestionId, transcriptSegments, text, ...rest } = s;

  return {
    id: suggestionId,
    text: isEmpty(transcriptSegments) ? text : transcriptSegments,
    ...rest,
  } as ClipSuggestion;
}

export const suggestedClipsSelector = createSelector(
  creationClipSuggestionsSelector,
  (suggestions): ClipSuggestion[] =>
    suggestions?.get('suggestions')?.reduce((acc, s) => {
      if (s.get('status') !== 'failed') {
        acc.push(createClipSuggestion(s.toJS()));
      }
      return acc;
    }, []) ?? [],
);

export const creationSelector = createSelector(
  creationIdSelector,
  creationsSelector,
  (creationId, creations) =>
    creations?.get(String(creationId))?.toJS() as CreationResponse,
);

export const hasCreationsSelector = createSelector(
  creationsSelector,
  creations => creations !== undefined,
);

export const suggestionSelector = (state: State, id: number) => {
  const suggestion = creationSuggestionSelector(id, state);

  if (!suggestion) {
    return undefined;
  }

  return createClipSuggestion(suggestion);
};
